var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9260",
    "data-name": "Group 9260",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.75,
    height: 14.874,
    viewBox: "0 0 12.75 14.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3139",
    "data-name": "Rectangle 3139",
    width: 12.75,
    height: 14.874,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9259",
    "data-name": "Group 9259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M6.366,221.276H1.718a1.986,1.986,0,0,1-.614-.084,1.592,1.592,0,0,1-1.089-1.383c-.009-.124-.014-.249-.014-.373q0-1.469,0-2.938a.5.5,0,0,1,.162-.386.511.511,0,0,1,.577-.1.512.512,0,0,1,.322.48q0,1.556,0,3.113a.644.644,0,0,0,.09.357.5.5,0,0,0,.37.239,1.7,1.7,0,0,0,.215.015q4.653,0,9.305,0a.932.932,0,0,0,.27-.034.5.5,0,0,0,.362-.413,1.2,1.2,0,0,0,.017-.206q0-1.531,0-3.063a.5.5,0,0,1,.167-.392.509.509,0,0,1,.578-.092.488.488,0,0,1,.314.476q.005,1.6,0,3.2a1.6,1.6,0,0,1-.244.833,1.456,1.456,0,0,1-1.068.723,2.759,2.759,0,0,1-.413.033q-2.328,0-4.657,0",
    transform: "translate(0 -206.401)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M63.637,1.822v.107q0,4.6,0,9.205a.539.539,0,0,0,.131.374.533.533,0,0,0,.93-.363q0-4.627,0-9.255V1.8a.444.444,0,0,1,.05.036q1.112,1.112,2.223,2.225a.518.518,0,0,0,.613.118.527.527,0,0,0,.294-.434.46.46,0,0,0-.113-.346c-.094-.112-.2-.216-.3-.32Q66.038,1.648,64.612.223a.69.69,0,0,0-.267-.191.529.529,0,0,0-.58.154q-.279.3-.566.583-1.069,1.073-2.141,2.143c-.129.129-.259.258-.387.388a.642.642,0,0,0-.179.275.491.491,0,0,0,.122.491.483.483,0,0,0,.686.047c.2-.179.4-.367.591-.558q.722-.716,1.438-1.438c.082-.082.16-.168.24-.252.017-.017.035-.033.053-.049l.016.007",
    transform: "translate(-57.792 0)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c3cfdb5078475c3ffd4a4ca15fcd3a24.svg";
export { ForwardRef as ReactComponent };